import { DynamicGraphData } from 'pages/dynamic-pricing'
import Chart from "react-apexcharts"
import React, { FC, useEffect, useRef, useState } from 'react'
import { tooltipFormat } from 'utils/formatDate'
import { getRandomColor } from 'utils/GenerateColors'


interface DynamicGraphProps{
dynamicGraphData: DynamicGraphData[]
}

interface SeriesSyntax {

  name: string,
  color: string,
  data: number[] | undefined

}

const DynamicGraph: FC<DynamicGraphProps> = ({dynamicGraphData,}) => {


  const [salesForecastSeries, setSalesForecastSeries] = useState<SeriesSyntax[]>([])
  const [salesHistorySeries, setSalesHistorySeries] = useState<SeriesSyntax[]>([])

  // const [LegendNames, setLegendNames] = useState<string[]>([])
  const chartRef = useRef<any>(null);

  const [date, setDate] = useState({
    // pastDate: "",
    futureDate: "",
    lengthOfInventory: null
  })

useEffect(()=>{

if(dynamicGraphData){
  makeDynamicPlot()
}

}, [dynamicGraphData])



const makeDynamicPlot = ()=>{

  let salesForecastArray: any = []
  let SalesHistoryArray: any = []

  let productNames: string[] = []
  let colorIndex = 0


  dynamicGraphData?.forEach((obj: DynamicGraphData) => {


    const { forecast,  product_name } = obj

    const localInventoryData = forecast.length > 0 ? forecast.map((item: any) => ({ x: item?.week_start, y: item?.forecast_price })) : []
    // const localSalesData = history.length > 0 ? history.map((item: any) => ({ x: item?.week_start, y: item?.history_price })) : []

    const { randomDarkColor, randomLightColor } = getRandomColor(colorIndex)


    salesForecastArray.push({ name: `${product_name}(SF)`, color: randomDarkColor, data: localInventoryData, })
    // SalesHistoryArray.push({ name: `${product_name}(SH)`, color: randomLightColor, data: localSalesData, })


    productNames.push(product_name)


    if (colorIndex < 4) {
      colorIndex = colorIndex + 1

    }
    else {
      colorIndex = 0
    }
  })


  // const maxLengthObjectSales = SalesHistoryArray.reduce((max: any, current: any) => current.data.length > max.data.length ? current : max, SalesHistoryArray[0]);

  const maxLengthObjectSalesForecast = salesForecastArray.reduce((max: any, current: any) => current.data.length > max.data.length ? current : max, salesForecastArray[0])

  setDate(prev => ({
    ...prev, futureDate: maxLengthObjectSalesForecast?.data?.[maxLengthObjectSalesForecast?.data?.length - 1]?.x,
    lengthOfInventory: maxLengthObjectSalesForecast?.data?.length, 
    // pastDate: maxLengthObjectSales?.data?.[0]?.x
  }))

  // setLegendNames(productNames)
  setSalesForecastSeries(salesForecastArray)
  // setSalesHistorySeries(SalesHistoryArray)



}



const currentDate = new Date().toISOString().slice(0, 10)
// const pastDateValue = date.pastDate
const forecastDateValue = salesForecastSeries ? (date.lengthOfInventory && date.lengthOfInventory > 1 ? date.futureDate : currentDate) : currentDate


const tooltipFunction = ({ series, seriesIndex, dataPointIndex, w }: any) => {



  const seriesName = w.globals.seriesNames[seriesIndex];
  let valueLabel
  let date

  // if (seriesName.includes('SH')) {
  //   valueLabel = 'Past Price';
  //   date = new Date(w.globals?.seriesX[0][dataPointIndex])


  // } else 
  if (seriesName.includes('SF')) {
    valueLabel = 'New Price';

    // date = new Date(w.globals?.seriesX[1][dataPointIndex])
    date = new Date(w.globals?.seriesX[0][dataPointIndex])
  }

  const yValue = series[seriesIndex][dataPointIndex];

  const xValue = tooltipFormat(date)

  return (
    `<div class="custom-chart-tooltip">
        <div class="tooltip-header"><b>${seriesName.split("(")[0]}</b> ${xValue}</div>
        <div class="tooltip-body">
          <p><b>${valueLabel} : </b> $${yValue.toLocaleString('en-US')}</p>
      </div>`
  );
}


  const chartConfiguration: any = {
    options: {
      chart: {
        id: "forecast-area",
        offsetY: 28,
        toolbar: {

          tools: {
            download: false,
          }

        },
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 800
        }
      },
      annotations: {
        xaxis: [//today
          {
            x: new Date(currentDate).getTime(),
            borderColor: "#FEB019",
            label: {
              borderColor: "#fff",
              style: {
                color: "#FEB019",
                background: "#fff",
                fontSize: "14px",
                fontWeight: 600,
              },
              offsetY: -23.5,
              text: "TODAY",
              orientation: "horizontal",
            },
            strokeDashArray: 10.5, // Adjust dash size
          },

          // {//past
          //   x: new Date(pastDateValue).getTime(),
          //   borderColor: "#fff",
          //   label: {
          //     borderColor: "#fff",
          //     style: {
          //       color: "#00A9A1",
          //       background: "#fff",
          //       fontSize: "14px",
          //       fontWeight: 600,
          //     },
          //     offsetY: -20,
          //     offsetX: 55,
          //     text: "Past Price",
          //     orientation: "horizontal",
          //   },
          //   strokeDashArray: 0, // Adjust dash size
          // },

          // forecastDateValue !== currentDate &&
          // {//forecast
          //   x: new Date(forecastDateValue).getTime(),
          //   borderColor: "#fff",
          //   label: {
          //     borderColor: "#fff",
          //     style: {
          //       color: "#3375A5",
          //       background: "#fff",
          //       fontSize: "14px",
          //       fontWeight: 600,
          //     },
          //     offsetY: -20,
          //     offsetX: -40,
          //     text: "New Price",
          //     orientation: "horizontal",
          //   },
          //   strokeDashArray: 0, // Adjust dash size
          // },


        ],
      },
      stroke: {
        curve: "straight",
        width: 1,
      },

      fill: {
        // Primary colors
        type: "gradient",
      },
      dataLabels: {
        enabled: false,
      },

      markers: {
        size: 3,
        shape: "circle",
        radius: 2,
      },
      tooltip: {
        enabled: true,
        followCursor: false,
        intersect: true,
        shared: false,
        custom: tooltipFunction,

      },
      legend: {
        // fontSize: "10.5px",
        show: false,
        // customLegendItems: LegendNames,
        // labels: {
        //   useSeriesColors: true
        // },
        // position: "bottom",
       
        // offsetY: 10,
        // height: 150,
       
        // itemMargin: {
        //   horizontal: 4, // Horizontal margin between items
        //   vertical: 10 // Vertical margin between items
        // }
      },
      grid: {
        padding: {
          right: 40,
          left: 15
        },
      },
      xaxis: {
        type: "datetime",
        labels: {
          datetimeUTC: false,
        },
        tooltip: {
          enabled: false // Ensure that the x-axis tooltip is disabled
        }
      },
      yaxis: {

        // tickAmount: 4 ,
        steps: 1,
        labels: {
          formatter: function formatter(value: number): string {

            const checkValue = value.toString().endsWith('000');

            const newValue = checkValue
              ? Number(value.toString().slice(0, -3)).toLocaleString('en-US') + 'K'  // Removes the last 3 digits, converts back to number, and formats it
              : (value % 1 === 0
                ? value.toLocaleString('en-US')
                : '');

            return newValue;

          },
          style: {
            colors: ['grey'],
            fontSize: "12px",
            fontWeight: 600,
            
          },
        },
      }
    },  //series is written this way so that legend color is customized
    // series: [...salesHistorySeries, ...salesForecastSeries,]
    series: salesForecastSeries
    ,
  }




  return (
    <section className="forecast-timeline">
      {(salesForecastSeries.length > 0 || salesHistorySeries.length > 0) ? (
        <Chart options={chartConfiguration.options} series={chartConfiguration.series} height={250} type="area" ref={chartRef} />

      ) : (
        <div className="custom-empty-message">No data available for this selection</div>
      )}
    </section>
  )
}

export default DynamicGraph
